import { Attrs, MinzeElement } from 'minze'

export interface LvcHandDrawnButton2 {
  inject: string
}

export class LvcHandDrawnButton2 extends MinzeElement {
  attrs: Attrs = [['inject', null]]
  parsedAttrs: any = {}
  static observedAttributes = ['inject']

  onAttributeChange(
    name?: string,
    oldValue?: string | null,
    newValue?: string | null
  ): Promise<void> | void {
    if (name === 'inject' && newValue) {
      this.parsedAttrs = JSON.parse(newValue)
      this.rerender()
    }
  }

  html = () => `
    <!-- Corners -->
    <svg viewBox="0 0 84 84" part="border-top-left">
      <path d="M83.333 83.333H5.922c-.554-14.342-.937-29.124-.613-41.822C5.867 19.67 23.903 6.878 44.527 6.824l38.806-.054v76.563Z" class="background-from"/>
      <path d="M83.333 2.604v8.333l-38.795.053c-18.339.049-34.567 11.206-35.064 30.628-.323 12.664.063 27.413.616 41.715H1.754c-.555-14.379-.935-29.197-.61-41.928.62-24.262 20.462-38.687 43.372-38.748l38.817-.053Z" class="border"/>
    </svg>
    <svg viewBox="0 0 84 84" part="border-top-right">
      <path d="M0 83.333h69.831c2.729 16.732 5.611 34.602 5.611 54.342v41.492H0V83.333ZM-3441.67 6.77l1155.19-1.591c223.779-.217 434.312-.421 598.029-.65 460.985-.643 1298.56.445 1688.45 2.087v76.717h-3441.67V6.77ZM0 6.616l1.2.003c17.479.074 32.992 8.495 44.667 20.829 11.662 12.323 19.712 28.767 22.308 45.505.508 3.281 1.046 6.602 1.596 9.969l.06.411H0V6.616Z" class="background-to"/>
      <path d="m-3441.67 2.604 1155.19-1.592c223.778-.217 434.311-.421 598.027-.649C-1227.462-.281-389.873.808-.003 2.449v8.334c-389.898-1.642-1227.46-2.73-1688.44-2.087-163.717.228-374.251.433-598.031.65l-1155.2 1.591V2.604ZM74.042 83.333c2.739 16.742 5.566 34.621 5.566 54.342v41.492h-8.333v-41.492c0-19.659-2.908-37.438-5.617-54.084l-.041-.258h8.425ZM0 2.449l1.218.003c18.641.079 35.223 8.977 47.675 22.132C61.126 37.51 69.57 54.758 72.292 72.314l.001.001c.506 3.27 1.042 6.579 1.59 9.936l.159 1.082h-8.425l-1.559-9.742C61.589 57.672 53.933 42.033 42.84 30.312 31.942 18.798 17.499 10.854 1.182 10.786L0 10.783V2.449Z" class="border"/>
    </svg>
    <svg viewBox="0 0 84 84" part="border-bottom-left">
      <path d="m83.333 78.831-11.627.003C37.311 78.792 11.335 46.9 7.153 14.158c-.203-1.591-.411-3.173-.618-4.747L5.371 0h77.962v78.831Z" class="background-from"/>
      <path d="m9.557 0 1.109 8.868.62 4.762c3.931 30.774 28.097 60.998 60.425 61.037l11.622-.003v8.333L71.701 83C35.239 82.956 7.454 49.395 3.02 14.686l-.616-4.732L1.185 0h8.372Z" class="border"/>
    </svg>
    <svg viewBox="0 0 84 84" part="border-bottom-right">
      <path d="M75.442 0v22.988c0 29.963-24.346 54.224-54.296 54.19L0 77.211V0h75.442Z" class="background-to"/>
      <path d="M74.042-95.833c2.739 16.742 5.566 34.62 5.566 54.341V0h-8.333v-41.492c0-19.658-2.908-37.438-5.617-54.083l-.041-.258h8.425ZM0 73.044v8.333l-427.33.668c-289.058.818-669.034 1.894-1320.86.868-468.174-.737-800.896-.389-1093.88-.083l-599.601.167v-8.333l599.592-.168c292.986-.306 625.714-.653 1093.9.084 651.808 1.025 1031.77-.05 1320.82-.868l427.353-.668ZM79.608 0v22.988c0 32.266-26.215 58.393-58.467 58.356L0 81.377v-8.333l21.151-.033c27.648.032 50.124-22.363 50.124-50.023V0h8.333Z" class="border"/>
    </svg>

    <!-- Sides -->
    <div part="border-top">
      <svg viewBox="0 0 3442 84" preserveAspectRatio="none">
        <defs>
          <linearGradient id="gradient">
            <stop offset="0%" class="gradient-stop-1" />
            <stop offset="100%" class="gradient-stop-2" />
          </linearGradient>
        </defs>
        <path d="m0 6.77 1155.19-1.591c223.779-.217 434.312-.421 598.029-.65 460.984-.643 1298.56.445 1688.45 2.087v76.717H-.001V6.77Z" style="fill:url(#gradient)"/>
        <path d="m0 2.604 1155.19-1.592c223.778-.217 434.311-.421 598.027-.649 460.991-.644 1298.58.445 1688.45 2.086v8.334c-389.898-1.642-1227.46-2.73-1688.44-2.087-163.718.228-374.251.433-598.031.65L-.004 10.937V2.604Z" class="border"/>
      </svg>
    </div>
    <div part="border-left">
      <svg viewBox="0 0 84 96" preserveAspectRatio="none">
        <path d="M83.333 95.833H5.371c-1.444-12.237-2.069-24.144.979-36.258.622-2.467.914-7.59.899-15.009-.014-7.241-.309-16.17-.674-25.928-.077-2.063-.158-4.163-.239-6.29L5.922 0h77.411v95.833ZM83.333-76.563l1155.19-1.591c223.779-.217 434.313-.422 598.029-.65 460.985-.643 1298.56.445 1688.45 2.087V0H83.332v-76.563ZM3525 95.833v77.211l-427.342.668c-289.054.818-669.025 1.893-1320.84.868-468.179-.737-800.904-.39-1093.89-.084l-599.596.168V95.833h3441.67Z" class="background-from"/>
        <path d="m10.09 0 .41 12.189.239 6.293c.367 9.814.663 18.794.677 26.076.015 7.927-.361 13.398-1.025 16.034-2.963 11.774-2.271 23.344-.834 35.241H1.185C-.265 83.257-.825 71.014 2.31 58.559v-.001c.578-2.298.786-7.074.773-13.984-.014-7.199-.309-16.077-.672-25.78-.077-2.062-.157-4.161-.239-6.287L1.754 0h8.336ZM83.333-80.73v8.334l-38.795.053c-18.339.049-34.567 11.206-35.064 30.627-.323 12.665.063 27.413.616 41.716H1.754c-.555-14.38-.935-29.197-.61-41.929.62-24.262 20.462-38.687 43.372-38.747l38.817-.054ZM9.557 95.833l1.109 8.868.62 4.763c3.931 30.774 28.097 60.997 60.425 61.036l11.622-.003v8.333l-11.632.004c-36.462-.045-64.247-33.605-68.681-68.314l-.616-4.733-1.219-9.954h8.372Z" class="border"/>
      </svg>
    </div>
    <div part="border-right">
      <svg viewBox="0 0 84 96" preserveAspectRatio="none">
        <path d="M0 0h69.831c2.729 16.731 5.611 34.601 5.611 54.342v41.491H0V0ZM0 95.833v77.211l-427.342.668c-289.054.818-669.025 1.893-1320.84.868-468.18-.737-800.905-.39-1093.89-.084l-599.596.168V95.833H.002ZM0-76.717l1.2.003c17.479.073 32.992 8.494 44.667 20.829 11.662 12.323 19.712 28.767 22.308 45.504.508 3.281 1.046 6.602 1.596 9.969l.06.412H0v-76.717Z" class="background-to"/>
        <path d="M74.042 0c2.739 16.742 5.566 34.62 5.566 54.342v41.491h-8.333V54.342c0-19.659-2.908-37.438-5.617-54.084L65.617 0h8.425ZM0-80.884l1.218.003c18.641.079 35.223 8.977 47.675 22.132 12.233 12.926 20.677 30.173 23.399 47.73h.001c.506 3.27 1.042 6.58 1.59 9.937L74.042 0h-8.425l-1.559-9.742C61.589-25.661 53.933-41.301 42.84-53.021 31.942-64.535 17.499-72.479 1.182-72.548L0-72.55v-8.334ZM79.608 95.833v22.988c0 32.267-26.215 58.394-58.467 58.356L0 177.211v-8.334l21.151-.033c27.648.032 50.124-22.362 50.124-50.023V95.833h8.333Z" class="border"/>
      </svg>
    </div>
    <div part="border-bottom">
      <svg viewBox="0 0 3442 84" preserveAspectRatio="none">
        <defs>
          <linearGradient id="gradient">
            <stop offset="0%" class="gradient-stop-1" />
            <stop offset="100%" class="gradient-stop-2" />
          </linearGradient>
        </defs>
        <path d="M3441.67-95.833h69.831c2.728 16.731 5.61 34.601 5.61 54.341V0h-75.441v-95.833ZM3441.67 0v77.211l-427.342.668c-289.054.818-669.025 1.893-1320.84.867-468.179-.736-800.904-.389-1093.89-.083L.002 78.831V0h3441.67Z" style="fill:url(#gradient)"/>
        <path d="M3441.67 73.044v8.333l-427.33.668c-289.058.818-669.035 1.894-1320.86.868-468.175-.737-800.896-.389-1093.88-.083L0 82.997v-8.333l599.591-.168c292.987-.306 625.715-.653 1093.9.084 651.808 1.025 1031.77-.05 1320.82-.868l427.354-.668ZM3521.28 0v22.988c0 32.266-26.215 58.393-58.467 58.356l-21.141.033v-8.333l21.15-.033c27.648.032 50.125-22.363 50.125-50.023V0h8.333ZM-73.776 0l1.109 8.868.62 4.762c3.931 30.774 28.097 60.998 60.425 61.037L0 74.664v8.333L-11.633 83c-36.462-.044-64.247-33.605-68.68-68.314l-.617-4.732L-82.148 0h8.372Z" class="border"/>
      </svg>
    </div>
  `

  css = () => `
    :host {}

    svg {
      display: block;
      width: 100%;
      height: 100%;
    }

    svg .border {
      fill: ${this.parsedAttrs.borderColor};
    }

    svg .background-from {
      fill: ${this.parsedAttrs.bgFromColor || this.parsedAttrs.bgColor};
    }

    svg .background-to {
      fill: ${this.parsedAttrs.bgToColor || this.parsedAttrs.bgColor};
    }

    svg .gradient-stop-1 {
      stop-color: ${this.parsedAttrs.bgFromColor || this.parsedAttrs.bgColor};
    }

    svg .gradient-stop-2 {
      stop-color: ${this.parsedAttrs.bgToColor || this.parsedAttrs.bgColor};
    }

    :host-context(.hover) svg .border {
      fill: ${this.parsedAttrs.hoverBorderColor || this.parsedAttrs.borderColor};
    }

    :host-context(.hover) svg .background-from {
      fill: ${this.parsedAttrs.hoverBgFromColor || this.parsedAttrs.hoverBgColor || this.parsedAttrs.bgFromColor || this.parsedAttrs.bgColor};
    }

    :host-context(.hover) svg .background-to {
      fill: ${this.parsedAttrs.hoverBgToColor || this.parsedAttrs.hoverBgColor || this.parsedAttrs.bgToColor || this.parsedAttrs.bgColor};
    }

    :host-context(.hover) svg .gradient-stop-1 {
      stop-color: ${this.parsedAttrs.hoverBgFromColor || this.parsedAttrs.hoverBgColor || this.parsedAttrs.bgFromColor || this.parsedAttrs.bgColor};
    }

    :host-context(.hover) svg .gradient-stop-2 {
      stop-color: ${this.parsedAttrs.hoverBgToColor || this.parsedAttrs.hoverBgColor || this.parsedAttrs.bgToColor || this.parsedAttrs.bgColor};
    }
  `
}
